import { Check, Globe, MousePointerClick, MessageSquare, Database, ShieldCheck } from 'lucide-react';
import { SITE } from '../data/site';

const SettingsPage = ({ user }) => (
  <div data-testid="admin-settings" className="max-w-3xl space-y-6">
    <h1 className="font-serif text-3xl font-medium text-ink">Settings</h1>

    <div className="border border-line bg-paper p-6">
      <h2 className="font-serif text-xl font-medium text-ink">Admin Account</h2>
      <dl className="mt-4 space-y-3 text-sm">
        <div className="grid grid-cols-[120px_1fr] gap-3"><dt className="text-xs font-semibold uppercase tracking-[0.15em] text-muted2">Name</dt><dd className="text-ink/80">{user.name}</dd></div>
        <div className="grid grid-cols-[120px_1fr] gap-3"><dt className="text-xs font-semibold uppercase tracking-[0.15em] text-muted2">Email</dt><dd className="text-ink/80">{user.email}</dd></div>
        <div className="grid grid-cols-[120px_1fr] gap-3"><dt className="text-xs font-semibold uppercase tracking-[0.15em] text-muted2">Role</dt><dd className="text-ink/80 capitalize">{user.role}</dd></div>
      </dl>
    </div>

    <div className="border border-line bg-paper p-6">
      <h2 className="font-serif text-xl font-medium text-ink">Site</h2>
      <dl className="mt-4 space-y-3 text-sm">
        <div className="grid grid-cols-[120px_1fr] gap-3"><dt className="text-xs font-semibold uppercase tracking-[0.15em] text-muted2">Business</dt><dd className="text-ink/80">{SITE.name} ({SITE.legalName})</dd></div>
        <div className="grid grid-cols-[120px_1fr] gap-3"><dt className="text-xs font-semibold uppercase tracking-[0.15em] text-muted2">Phone</dt><dd className="text-ink/80">{SITE.phone}</dd></div>
        <div className="grid grid-cols-[120px_1fr] gap-3"><dt className="text-xs font-semibold uppercase tracking-[0.15em] text-muted2">Email</dt><dd className="text-ink/80">{SITE.email}</dd></div>
      </dl>
    </div>

    <div className="border border-line bg-paper p-6">
      <h2 className="font-serif text-xl font-medium text-ink">System Status</h2>
      <ul className="mt-4 space-y-3 text-sm">
        {[
          [Globe, 'Visitor tracking active on all public pages'],
          [MousePointerClick, 'CTA, form, and chat events tracked'],
          [MessageSquare, 'Live chat widget live on the public site'],
          [Database, 'All data persisted in MongoDB'],
          [ShieldCheck, 'Admin APIs protected by JWT authentication'],
        ].map(([Icon, text]) => (
          <li key={text} className="flex items-center gap-3 text-ink/80">
            <span className="flex h-7 w-7 items-center justify-center bg-bronze/10"><Check className="h-4 w-4 text-bronze" /></span>
            <Icon className="h-4 w-4 text-muted2" /> {text}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default SettingsPage;
